import social_twitter from '@assets/westminster-social-twitter.png';
import social_instagram from '@assets/westminster-social-instagram.png';
import social_facebook from '@assets/westminster-social-facebook.png';
import social_linkedin from '@assets/westminster-social-linkedin.png';
import wcc_logo from '@assets/wcc_logo_white.png';

export const WCCFooterItems = {
  feedback: {
    url: 'https://www.westminster.gov.uk/form/page-feedback',
    text: 'Is there anything wrong with this page?',
  },
  menu: [
    {
      url: 'https://www.westminster.gov.uk/all-services',
      text: 'All council services',
    },
    {
      url: 'https://www.westminster.gov.uk/events',
      text: 'Events',
    },
    {
      url: 'https://www.westminster.gov.uk/news',
      text: 'News',
    },
    {
      url: 'https://www.westminster.gov.uk/jobs',
      text: 'Jobs',
    },
  ],
  logo: {
    url: 'https://www.westminster.gov.uk/',
    alt: 'MyWestminster dashboard (footer)',
    src: wcc_logo,
  },
  socialMedia: [
    {
      url: 'https://en-gb.facebook.com/CityWestminster/',
      alt: 'Social Icon - Facebook',
      src: social_facebook,
    },
    {
      url: 'https://www.instagram.com/citywestminster',
      alt: 'Social Icon - Instagram',
      src: social_instagram,
    },
    {
      url: 'https://twitter.com/CityWestminster',
      alt: 'Social Icon - Twitter',
      src: social_twitter,
    },
    {
      url: 'https://www.linkedin.com/company/westminster-city-council',
      alt: 'Social Icon - LinkedIn',
      src: social_linkedin,
    },
  ],
  bottomLinks: [
    {
      url: 'https://www.westminster.gov.uk/accessibility',
      text: 'Accessibility',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection/privacy',
      text: 'Cookies',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection',
      text: 'Data protection',
    },
    {
      url: 'https://www.westminster.gov.uk/data-protection/freedom-information',
      text: 'Freedom of information',
    },
    {
      url: 'https://www.westminster.gov.uk/sites/default/files/media/documents/WCC-PayGapReport2022-4.pdf',
      text: 'Gender pay gap',
    },
    {
      url: 'https://www.westminster.gov.uk/modern-slavery-statement',
      text: 'Modern Slavery',
    },
    {
      url: 'https://www.westminster.gov.uk/terms-and-conditions',
      text: 'Terms & conditions',
    },
    {
      url: 'https://www.westminster.gov.uk/about-council/contact-us',
      text: 'Contact us',
    },
  ],
};
